import React from 'react'

const PaNavigatorDisclaimer = ({ className = '' }) => (
  <div className={`alert alert-info ${className}`.trim()} role='note'>
    The PA navigator provides guidance for indirect orders through the wholesalers. Commercial terms for indirect orders may vary from commercial terms for direct orders placed through Origins Direct.
  </div>
)

export default PaNavigatorDisclaimer
